import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSendCircle = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M32 20C32 26.6274 26.6274 32 20 32C13.3726 32 8 26.6274 8 20C8 13.3726 13.3726 8 20 8C26.6274 8 32 13.3726 32 20ZM20.3139 27.9004C20.4193 27.9655 20.5407 27.9999 20.6646 28L20.7002 27.9987C20.8301 27.9917 20.955 27.9468 21.0596 27.8696C21.1642 27.7923 21.2439 27.6861 21.2888 27.5641L25.9564 14.8972C26.0005 14.7777 26.0095 14.6481 25.9822 14.5236C25.955 14.3992 25.8926 14.2852 25.8025 14.1951C25.7125 14.1051 25.5985 14.0427 25.474 14.0154C25.3496 13.9882 25.22 13.9972 25.1005 14.0413L12.4342 18.7095C12.3126 18.7547 12.2069 18.8345 12.1299 18.939C12.053 19.0434 12.0082 19.1681 12.001 19.2976C11.9939 19.4272 12.0246 19.556 12.0896 19.6683C12.1546 19.7807 12.2509 19.8716 12.3667 19.93L16.3267 21.9083C16.4336 21.9617 16.5528 21.9854 16.672 21.977C16.7912 21.9686 16.906 21.9284 17.0044 21.8606L21.3315 18.6675L18.1371 22.9946C18.0692 23.0931 18.029 23.2079 18.0206 23.3272C18.0123 23.4465 18.036 23.5659 18.0893 23.6729L20.0677 27.6316C20.1233 27.7423 20.2085 27.8353 20.3139 27.9004Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgSendCircle);
export default ForwardRef;
